module.exports = __webpack_public_path__ + "img/c5201909-4.af54fa23.jpg";